











import { Component, Vue, Prop } from 'vue-property-decorator';
import { Button } from '@/pages/profile/components';
import { IFooter } from './types';

@Component({
  components: {
    Button,
  },
})
export default class Footer extends Vue implements IFooter {
  @Prop({ type: String, default: '' })
  readonly actionText!: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/certificate/components/footer/Footer.vue